"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var configuration_1 = require("../configuration");
/**
 * #config BaseRpcDriver
 */
function x() {} // eslint-disable-line @typescript-eslint/no-unused-vars
var BaseRpcDriverConfigSchema = (0, configuration_1.ConfigurationSchema)('BaseRpcDriver', {
  /**
   * #slot
   */
  workerCount: {
    type: 'number',
    description: 'The number of workers to use. If 0 (the default) JBrowse will decide how many workers to use.',
    defaultValue: 0
  }
}, {
  explicitlyTyped: true
});
exports.default = BaseRpcDriverConfigSchema;